export const GET_PREBOOKS_REQUEST = 'GET_PREBOOKS_REQUEST';
export const GET_PREBOOKS_ERROR = 'GET_PREBOOKS_ERROR';
export const GET_PREBOOKS_SUCCESS = 'GET_PREBOOKS_SUCCESS';
export const PUT_PREBOOKS_REQUEST = 'PUT_PREBOOKS_REQUEST';
export const PUT_PREBOOKS_ERROR = 'PUT_PREBOOKS_ERROR';
export const PUT_PREBOOKS_SUCCESS = 'PUT_PREBOOKS_SUCCESS';
